import React from "react";
import { Form, InputNumber } from "antd";
import Props from "./Props";

const Input: React.FC<Props> = ({ name, config, ...rest }) => {
  return (
    <Form.Item
      name={name}
      label={config.label}
      rules={config.validationRules}
      labelCol={{ span: 24 }}
      {...(config.extra || {})}
      {...rest}
    >
      <InputNumber placeholder={config.placeholder} />
    </Form.Item>
  );
};

export default Input;
